import { Button, CircularProgress, DialogActions, DialogContentText, Divider, Typography } from '@material-ui/core';
import { Dispatch } from '@reduxjs/toolkit';
import React, { Component, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { AppDispatch, AppState } from 'store';
import { dialogClose } from 'store/dialog/dialog.actions';
import { DialogOpenPayloadJobs } from 'store/dialog/dialog.interface';
import { modifyLanguages } from 'store/projects/projects.actions';
import { ModifyLanguagesPayload } from 'store/projects/projects.interface';
import { getJobActionSpinnerSelector } from 'store/spinner/spinner.selectors';
import { XTMJobStatus } from 'utils/restApplicationClient';
import { CustomDialogButtonContainer, CustomDialogContent } from '../CustomDialog.styled';
import { IJobActionProps } from './JobAction';

interface IProps {
  statuses?: Array<XTMJobStatus>;
  projectId: string;
  projectLanguages: Array<string>;
  jobs: DialogOpenPayloadJobs;
}
interface IDispatchProps {
  dialogClose: () => AppDispatch;
  modifyLanguages: (payload: ModifyLanguagesPayload) => AppDispatch;
}

interface IStateProps {
  jobActionSpinner: boolean;
}

type PropType = IJobActionProps & WithTranslation & IDispatchProps & IStateProps & IProps;

class RemoveLanguage extends Component<PropType> {
  private handleClose = (): void => {
    const { dialogClose } = this.props;
    dialogClose();
  };

  handleRemoveClick = (): void => {
    const { projectLanguages, projectId, modifyLanguages } = this.props;

    modifyLanguages({
      projectId,
      languages: projectLanguages,
      operation: 'REMOVE',
    });
  };

  render(): JSX.Element {
    const { jobActionSpinner, t } = this.props;

    return (
      <Fragment>
        <CustomDialogContent>
          <DialogContentText>
            <Typography component="span" color="textPrimary">
              {t('modal.removeLanguageAction')}
            </Typography>
          </DialogContentText>
        </CustomDialogContent>
        <Divider />
        <DialogActions>
          <CustomDialogButtonContainer>
            <Button variant="contained" onClick={this.handleRemoveClick} color="secondary" disabled={jobActionSpinner}>
              {jobActionSpinner ? <CircularProgress size="24px" color="secondary" /> : t('modal.ok')}
            </Button>
            <Button variant="outlined" onClick={this.handleClose} disabled={jobActionSpinner}>
              {t('common.cancel')}
            </Button>
          </CustomDialogButtonContainer>
        </DialogActions>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: AppState): IStateProps => ({
  jobActionSpinner: getJobActionSpinnerSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  dialogClose: (): AppDispatch => dispatch(dialogClose()),
  modifyLanguages: (payload: ModifyLanguagesPayload): AppDispatch => dispatch(modifyLanguages(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RemoveLanguage));
